/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export enum DomainOrderStatusEnum {
  'OrderStatusProcess' = 'process',
  'OrderStatusDone' = 'done',
  'OrderStatusCancel' = 'cancel',
}

export type DomainOrderStatus = DomainOrderStatusEnum